<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchDictionaryList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
                v-for="item in COMMON_STATUS"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchDictionaryList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="eventName" label="事件名称" min-width="150">
            </el-table-column>
            <el-table-column prop="remarks" label="事件描述" min-width="150">
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" min-width="150">
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('securities', scope.row)"
                    plain
                    v-if="editShow"
                    size="small"
                >关联券
                </el-button
                >
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    v-if="editShow"
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑/新增券事件"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="480px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-form-item label="事件名称：" prop="eventName">
            <el-input
                clearable
                placeholder="请填写事件名称"
                v-model="params.eventName"
            ></el-input>
          </el-form-item>
          <el-form-item label="事件描述：" prop="remarks">
            <el-input
                clearable
                placeholder="请填写事件描述"
                v-model="params.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="事件步骤：" prop="step">
            <el-input
                clearable
                type="number"
                placeholder="请填写事件步骤"
                v-model="params.step"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      loading1: false, //加载中
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        eventName: [
          {required: true, message: "请填写事件名称", trigger: "change"},
        ],
        step: [
          {required: true, message: "请填写事件步骤", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //二级--列表
      addShow: true,
      deleteShow: true,
      editShow: true,
      statusShow: false,
      searchShow: true,
    };
  },
  created() {
    this.getVipRightList();
    // this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:enums:query') {
            this.searchShow = true
          }
          if (item.code == 'system:enums:add') {
            this.addShow = true
          }
          if (item.code == "system:enums:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:enums:edit") {
            this.editShow = true
          }
          if (item.code == "system:enums:status") {
            this.statusShow = false
          }
        })
      }
    },
    SearchDictionaryList() {
      this.page.pageNo = 1
      this.getVipRightList()
    },
    /**
     *  get list 字典列表
     */
    async getVipRightList() {
      let http = "/coupon/event/list";
      this.loading = true;
      // const { data: resData } = await this.$get(http, {
      //   params: { ...this.search, ...this.page },
      // });
      const {data: resData} = await this.$get(http);
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
      // this.page.count = resData.page.count;
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      } else if(type == 'addNext'){
        //添加
        this.params = {};
        this.dialogVisible = true;
      }else if(type == 'securities'){
        this.$router.push({name:'RELATED_SECURITIES',query:{id:row.id,name:row.eventName}})
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post(
              "/coupon/event/save",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.getVipRightList();
          this.dialogVisible = false
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/coupon/event/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipRightList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipRightList();
    },
  },
};
</script>
<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}
</style>
